<template>
  <div class="GlobalFormDemo">
    <GlobalForm
      :init-data="initData"
      :form-item-list="formItemList"
      :inline="true"
      :labelWidth="90"
      :needBtnLoading="true"
      round
      @handleConfirm="handleConfirm"
      confirmBtnName="查询"
    >
      <el-form-item class="el_from" label="问题类型" slot="type">
        <el-select v-model="formData.questionTypeId" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in option"
            :key="item.questionTypeId"
            :label="item.questionTypeName"
            :value="item.questionTypeId"
          ></el-option>
        </el-select>
      </el-form-item>
      <div slot="AddSlot">
        <el-button size="small" type="warning" @click="orderClick"
          >导入平台问题</el-button
        >
        <el-button size="small" type="primary" @click="addModel"
          >+ 添加问题</el-button
        >
      </div>
    </GlobalForm>

    <!-- 添加问题 -->
    <el-dialog
      title="添加问题"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="500px"
      @closed="handleDialogClosed"
    >
      <el-form
        :model="formDataDialog"
        :rules="formRulesDialog"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="问题类型" prop="questionTypeId">
          <el-select v-model="formDataDialog.questionTypeId" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in option"
              :key="item.questionTypeId"
              :label="item.questionTypeName"
              :value="item.questionTypeId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题名称" prop="questionName">
          <el-input
            v-model="formDataDialog.questionName"
            placeholder="请输入问题名称（20字内）"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="问题回复" prop="questionAnswer">
          <el-input
            type="textarea"
            maxlength="200"
            v-model="formDataDialog.questionAnswer"
            :autosize="{ minRows: 7, maxRows: 7 }"
            show-word-limit
            placeholder="请输入问题回复"
            resize="none"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="FromBack">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="handleConfirmDialog('ruleForm')"
          >确认</el-button
        >
      </span>
    </el-dialog>

    <!-- 导入订单 -->
    <DialogTbale
      :show="orderDialogVisible"
      :loading="loading"
      title="导入平台问题"
      :columns="tableColumns"
      :isSelection="true"
      :data="dataList"
      ref="multipleTable"
      :currentPage="dialogPage.pageNum"
      :total="dialogPage.total"
      :pageSize="dialogPage.pageSize"
      :width="1200"
      @onClose="orderHandleDialogClosed"
      @handleCurrentChange="dialogCurrentChangeDialog"
      @handleSelect="handleSelect"
    >
      <div class="flex flexwarp flex-jb">
        <div class="flex mb-20">
          <label class="label">问题类型</label>
          <el-select
            size="mini"
            v-model="orderFormData.questionTypeId"
            clearable
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in option"
              :key="item.questionTypeId"
              :label="item.questionTypeName"
              :value="item.questionTypeId"
            ></el-option>
          </el-select>
        </div>
        <div class="flex mb-20" style="margin-left: 30px">
          <label class="label">最近更新时间</label>
          <el-date-picker
            type="daterange"
            size="mini"
            v-model="orderTime"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="true"
          >
          </el-date-picker>
        </div>

        <div style="flex: 1; margin-left: 20px" class="mb-20">
          <el-button size="mini" type="primary" @click="orderSearch">
            查询
          </el-button>
        </div>
      </div>
      <!-- <el-table-column label="订单金额" slot="finalPrice" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.finalPrice ? "￥" + row.finalPrice : "--" }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="回复" slot="questionAnswer" align="center">
        <template slot-scope="{ row }">
          <el-tooltip
            v-if="row.questionAnswer"
            class="item"
            effect="dark"
            :content="row.questionAnswer"
            placement="top"
          >
            <div class="Remarks">
              {{ row.questionAnswer }}
            </div>
          </el-tooltip>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <div
        slot="tableFooter"
        class="flex flex-je"
        style="padding-bottom: 20px; box-sizing: border-box"
      >
        <el-button size="small" @click="orderFromBack">取 消</el-button>
        <el-button size="small" type="primary" @click="orderCommit"
          >确定</el-button
        >
      </div>
    </DialogTbale>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";
export default {
  name: "Form",
  props: {
    accountType: {
      require: true,
      type: String,
    },
    option: {
      type: Array,
      default() {
        return [];
      },
    }
  },
  data() {
    return {
      initData: null,
      dialogVisible: false,
      orderDialogVisible: false,
      loading: false,
      dialogPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      formDataDialog: {
        questionAnswer: "",
        questionName: "",
        questionTypeId: "",
      },
      formRulesDialog: {
        questionTypeId: [
          {
            required: true,
            trigger: "blur",
            message: "请选择问题类型",
          },
        ],
        questionName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入问题名称",
          },
        ],
        questionAnswer: [
          {
            required: true,
            trigger: "blur",
            message: "请输入问题回复",
          },
        ],
      },
      dataList: [],
      tableColumns: [
        { label: "问题类型", prop: "questionTypeName" },
        { label: "问题", prop: "questionName" },
        // { label: "回复", prop: "questionAnswer" },
        { slotName: "questionAnswer" },
        { label: "最近更新时间", prop: "updateTime" },
        // { slotName: "num" },
      ],
      formItemList: [{ slotName: "type" }],
      formData: {
        questionTypeId: "",
      },
      orderFormData: {
        endTime: "", //订单成交结束时间【时间戳】
        startTime: "", //	订单成交开始时间【时间戳】
        questionTypeId: "", //品牌编号
      },
      orderTime: null,
      storageArr: [], // 存取翻页前的数据
      storageArr2: [], // 存取翻页前的数据
      selectOrderList: [], //回显选择打钩
    };
  },
  created() {
    this.handleConfirm();
  },
  watch: {},
  methods: {
    handleConfirm(data,cd) {
      let SeachParams = {};
      SeachParams = {
        questionTypeId: this.formData.questionTypeId,
        pageNum: 1,
        pageSize: 10,
        disuseLoding: () => {
          if (typeof cd === 'function') {
            cd()
          }
        },
      };
      console.log("提交了form", SeachParams);
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
    // 分配数量
    handleDialogClosed() {
      this.dialogVisible = false;
    },
    addModel(val) {
      this.formDataDialog.questionAnswer = "";
      this.formDataDialog.questionName = "";
      this.formDataDialog.questionTypeId = "";
      this.dialogVisible = true;
    },
    FromBack() {
      this.dialogVisible = false;
    },
    // 添加问题
    handleConfirmDialog(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _api.questionSaveOrUpdate(this.formDataDialog).then((res) => {
            if (res.code === 1) {
              this.handleConfirm();
              this.dialogVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },

    // 导入订单
    orderClick() {
      // let startTime = moment()
      //   .day(moment().day() - 6)
      //   .format("YYYY-MM-DD 00:00:00"); // 当前时间往前推7天的时间
      // let endTime = moment().format("YYYY-MM-DD 23:59:59");
      // this.orderTime = [startTime, endTime];
      // this.orderFormData.startTime = new Date(startTime).getTime();
      // this.orderFormData.endTime = new Date(endTime).getTime();
      this.orderFormData.startTime = "";
      this.orderFormData.endTime = "";
      this.orderFormData.questionTypeId = "";
      this.selectOrderList = [];
      this.orderDialogVisible = true;
      this.dialogCurrentChangeDialog();
    },
    orderFromBack() {
      this.orderDialogVisible = false;
    },
    orderHandleDialogClosed() {
      this.orderDialogVisible = false;
    },
    // 查询
    orderSearch() {
      if (
        this.orderFormData.endFinalPrice < this.orderFormData.startFinalPrice
      ) {
        this.$message.error("上限价格不能小于起始价格");
        this.orderFormData.endFinalPrice = "";
        return;
      }
      this.dialogCurrentChangeDialog(1);
    },
    dialogCurrentChangeDialog(val) {
      this.loading = true;
      if (this.orderTime) {
        this.orderFormData.startTime = new Date(this.orderTime[0]).getTime();
        this.orderFormData.endTime =
          new Date(this.orderTime[1]).getTime() + 86399000;
      }
      if (val) {
        this.dialogPage.pageNum = val;
      }
      if (this.dataList.length) {
        this.dataList.forEach((item) => {
          this.storageArr.forEach((ele) => {
            if (item.id == ele.id) {
              this.storageArr2.forEach((j, i) => {
                if (j.id == item.id) {
                  this.storageArr2.splice(i, 1);
                }
              });
              this.storageArr2.push(item);
            }
          });
        });
      }
      console.log(this.storageArr2, "this.storageArr2");
      let params = {
        pageNum: this.dialogPage.pageNum,
        pageSize: this.dialogPage.pageSize,
        startTime: this.orderFormData.startTime, //订单成交结束时间【时间戳】
        endTime: this.orderFormData.endTime, //	订单成交开始时间【时间戳】
        questionTypeId: this.orderFormData.questionTypeId, //机型名称
      };
      _api
        .platformQuestion(params)
        .then((res) => {
          this.dataList = res.data.records;
          this.dialogPage.pageNum = res.data.current;
          this.dialogPage.total = res.data.total;
          let _rows = [];
          this.dataList.forEach((item) => {
            if (this.selectOrderList.some((ele) => ele.id == item.id)) {
              _rows.push(item);
            }
            return item;
          });
          this.toggleSelection(_rows);
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    orderCommit() {
      let arr = [];
      this.selectOrderList.forEach((item) => {
        arr.push(item.id);
      });
      _api.importQuestion({ ids: arr }).then((res) => {
        this.orderDialogVisible = false;
        this.handleConfirm();
      });
    },
    handleSelect(e) {
      console.log(e);
      this.selectOrderList = this.selectOrderList.filter((item) => {
        return !this.dataList.some((ee) => ee.id == item.id);
      });
      let jsonArr = e;
      let newJson = this.selectOrderList; //盛放去重后数据的新数组
      for (let item1 of jsonArr) {
        //循环json数组对象的内容
        let flag = true; //建立标记，判断数据是否重复，true为不重复
        for (let item2 of newJson) {
          //循环新数组的内容
          if (item1.id == item2.id) {
            //让json数组对象的内容与新数组的内容作比较，相同的话，改变标记为false
            flag = false;
          }
        }
        if (flag) {
          //判断是否重复
          newJson.push(item1); //不重复的放入新数组。  新数组的内容会继续进行上边的循环。
        }
      }
      this.selectList = newJson;

      this.selectOrderList.push(...this.selectList);
      let obj = {};
      let peon = this.selectOrderList.reduce((cur, next) => {
        obj[next.id] ? "" : (obj[next.id] = true && cur.push(next));
        return cur;
      }, []);
      this.selectOrderList = peon;
    },

    // 回显显示效果
    toggleSelection(rows) {
      console.log(rows);
      Promise.resolve().then(() => {
        if (rows && rows.length) {
          rows.forEach((row) => {
            console.log(row);
            this.$refs.multipleTable.setSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
  .price_input {
    width: 195px;
    background-color: #ffffff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #e4ecfd;
    box-sizing: border-box;
    color: #666666;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    height: 30px;
    > input {
      outline: 0;
      width: 70px;
      text-align: center;
    }
  }
  .mb-10 {
    margin-bottom: 10px;
  }
  .mt-10 {
    margin-top: 10px;
  }
  .mt-20 {
    margin-top: 20px;
  }
  .mb-20 {
    margin-bottom: 20px;
  }
  .mr-50 {
    margin-right: 50px;
  }
  .ml-10 {
    margin-left: 10px;
  }
  .mr-10 {
    margin-right: 10px;
  }
  .font-w {
    font-weight: bold;
  }
  .flex {
    display: flex;
    align-items: center;
  }

  .flexwarp {
    display: flex;
    flex-wrap: wrap;
  }
  .flex-jb {
    display: flex;
    justify-content: space-between;
  }
  .flex-as {
    display: flex;
    align-items: flex-start;
  }
  .flex-je {
    display: flex;
    justify-content: flex-end;
  }
  .label {
    white-space: nowrap;
    margin-right: 10px;
    // width: 56px;
  }
  .images-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .images-box > span {
    color: #0981ff;
    cursor: pointer;
  }
  .text-down {
    color: #0981ff;
    cursor: pointer;
    text-decoration: underline;
  }
  /deep/input::-webkit-inner-spin-button {
    display: none !important;
  }
}
.Remarks {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; //控制行数
  overflow: hidden;
}
</style>
